import React from 'react';
import { Container } from './ui/Container';
export function Mission() {
  return <section id="mission" className="py-20 bg-[#FAFAF8] border-y border-[#E5E5E0]" data-id="element-66">
      <Container data-id="element-67">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-68">
          <div data-id="element-69">
            <h2 className="text-4xl font-serif text-[#2D2D2D] mb-6" data-id="element-70">
              Our Mission
            </h2>
            <div className="space-y-6 text-lg text-[#555555] leading-relaxed" data-id="element-71">
              <p data-id="element-72">
                The Good Father Project is an initiative dedicated to
                recognizing and encouraging the vital role fathers and father figures play in their
                children's lives. We believe that fatherhood is not just a
                biological fact, but a daily practice of presence and care.
              </p>
              <p data-id="element-73">
                Our mission is to create spaces for reflection and connection,
                and encourage and celebrates genuine, quiet
                commitment. We work directly with institutions to facilitate
                these moments of recognition.
              </p>
              <p data-id="element-74">
                By focusing on the simple, profound act of being present, we
                help build stronger families and more resilient communities for
                the next generation.
              </p>
            </div>
          </div>
          <div className="bg-white p-12 rounded-sm border border-[#E5E5E0]" data-id="element-75">
            <h3 className="text-2xl font-serif text-[#3D5A4C] mb-6" data-id="element-76">
              Core Values
            </h3>
            <ul className="space-y-4" data-id="element-77">
              {[{
              title: 'Presence',
              desc: 'Showing up consistently, without need for applause.'
            }, {
              title: 'Reflection',
              desc: 'Taking time to think deeply about our impact.'
            }, {
              title: 'Community',
              desc: 'Supporting one another in the journey of parenthood.'
            }, {
              title: 'Generational Impact',
              desc: 'Building a legacy of care for the future.'
            }].map(item => <li key={item.title} className="flex flex-col" data-id="element-78">
                  <span className="font-serif text-xl text-[#2D2D2D]" data-id="element-79">
                    {item.title}
                  </span>
                  <span className="text-[#666666]" data-id="element-80">{item.desc}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </Container>
    </section>;
}